import { makeStyles } from '@mui/styles'

const sideBarStyle = makeStyles(() => ({
  navList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'center',
    position: 'absolute',
    bottom: '0px',
    right: 0,
    left: 0,
    width: '-webkit-fill-available',
  },
  icon: {},
  nav: { height: '100vh' },
  navListElement: {
    height: '45px',
  },
}))

export default sideBarStyle
